// src/components/RedirectKeepingSearch.js — a renamed route keeps its query
// (mission 021-01: /my-agents?tab=media → /create?tab=media).
import { Navigate, useLocation } from 'react-router-dom';

export default function RedirectKeepingSearch({ to }) {
  const { search } = useLocation();
  return <Navigate to={`${to}${search}`} replace />;
}
